import {FC} from 'react';
import {Checkbox} from '@tickchak/react-share/app';
import ticketColors from '../../../../../assets/objects/TicketColors';
import * as css from './TicketsSection.css';
import {getPriceText, parseImagePath} from './ticketsSection.utils';

interface TicketRowProps {
    ticket: any;
    checked: boolean;
    ticketsIcon: string | null;
    currencySymbol: string;
    color: string;
    onToggle: () => void;
}

const TicketRow: FC<TicketRowProps> = ({ticket, checked, ticketsIcon, currencySymbol, color, onToggle}) => {
    const image = parseImagePath(ticket.imgData);
    const icon = !image && ticketsIcon ? ticketColors[color]?.[ticketsIcon] : null;
    return (
        <css.card $checked={checked}>
            <css.sticker $color={`#${color}`} $image={image || undefined} $icon={icon || undefined} />
            <css.cardInfo>
                <css.titleGroup>
                    <Checkbox checked={checked} shape="square" onChange={onToggle} ariaLabel={ticket.title} />
                    <css.title>{ticket.title}</css.title>
                </css.titleGroup>
                <css.price>{getPriceText(ticket, currencySymbol)}</css.price>
            </css.cardInfo>
        </css.card>
    );
};

export default TicketRow;
